<script>
import { mapState, mapActions } from "vuex";
import NavigationWrapper from "@/components/NavigationWrapper";
import PasswordChangeForm from "@/pages/Account/General/PasswordChangeForm";
import AccountSettingsForm from "@/pages/Account/General/AccountSettingsForm";

export default {
  // Included components
  components: {
    NavigationWrapper,
    PasswordChangeForm,
    AccountSettingsForm,
  },

  computed: {
    // Mapped vuex state
    ...mapState(["user"]),
  },

  // When the page is loaded, get the user's information
  async created() {
    await this.getUser();
  },

  methods: {
    // Mapped vuex actions
    ...mapActions(["getUser"]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item active>Account</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Account</h1>
    <AccountSettingsForm class="mb-3" />
    <h3 class="mb-3">Email</h3>
    <b-card class="mb-3">
      <b>Email</b>
      {{ user.email }}
    </b-card>
    <h3 class="mb-3">Change Password</h3>
    <PasswordChangeForm class="mb-3" />
  </NavigationWrapper>
</template>
